import { assertNotUndefined, isBlank, parseString, substringAfterLast } from "@de-xima/xima-common-js-lang";
import $ from "jquery";
import { onClick } from "@de-xima/xima-common-js-dom";

import { getWidgetByVar, runRemoteCommand } from "./Util.ts";

/**
 * When a client node was selected, cascades the event to other nodes.
 * - When a project node was selected, also selects the parent node.
 * @param widgetVar The widget variable for the project tree.
 * @param source The source of the event, e.g. `userPortalForm:tabView:projectTree`
 * @param params The AJAX parameters, e.g. `[{name: 'userPortalForm:tabView:projectTree_instantUnselection', value: '3'}]`
 */
export function onNodeSelected(widgetVar: string, source: string, params: PrimeFaces.ajax.RequestParameter[]): void {
  const tree = getWidgetByVar(widgetVar, PrimeFaces.widget.VerticalTree);
  assertNotUndefined(tree);
  const rowKeys = params.filter((param) => param.name === `${source}_instantSelection`).map((param) => param.value);
  for (const rowKey of rowKeys) {
    if (typeof rowKey === "string") {
      const nodes = tree.findNodes([rowKey]);
      for (const node of nodes) {
        if (node.attr("data-nodetype") === "project") {
          const parentNode = node.parent().closest(".ui-treenode");
          if (parentNode.length > 0) {
            tree.selectNode(parentNode);
            // Bug in PrimeFaces: The node's checkbox is changed.
            parentNode
              .children(".ui-treenode-content")
              .find(".ui-chkbox-icon")
              .removeClass("ui-icon-blank")
              .addClass("ui-icon-check");
          }
        }
      }
    }
  }
}

export async function setUserPortalProject(element: HTMLElement, event: MouseEvent): Promise<void> {
  const node = $(element).closest("li.ui-treenode");
  const projectDataKey = parseString(node.attr("data-datakey"));
  const nodeType = parseString(node.attr("data-nodetype"));
  if (isBlank(projectDataKey) || nodeType !== "project") {
    return;
  }

  event.stopPropagation();

  const parentNode = node.parent().closest(".ui-treenode");
  const clientDataKey =
    parentNode.attr("data-nodetype") === "client" ? parseString(parentNode.attr("data-datakey")) : "";

  try {
    await runRemoteCommand(BackendCommand?.setUserPortalProject, [
      { name: "projectId", value: substringAfterLast(projectDataKey, ":") },
      { name: "clientId", value: substringAfterLast(clientDataKey, ":") },
    ]);
  } catch (e) {
    console.error("Unable to select project", e);
  }
}

function onPortalImageClick(event: Event): void {
  const image = event.target;
  if (image instanceof HTMLImageElement) {
    window.open(image.src, "_blank", "noopener noreferrer");
  }
}

export function initUserPortalConfig(): void {
  onClick(document, ".user-portal-row__image", onPortalImageClick);
}
